export default "__VITE_ASSET__fdc337a8__"